function loadTranscript(view) {
    return () => import( /* webpackChunkName: "internships-[request]" */ `../components/Transcript/${view}.vue`)
}
const transcriptRoute = [
    {
        path: '/student-spama/:npm',
        name: 'Student Spama',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['wadek']
        },
        component: loadTranscript('SPAMA'),
    },
    {
        path: '/student-spp/:npm',
        name: 'Student SPP',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator']
        },
        component: loadTranscript('SPP'),
    },
    {
        path: '/transcript/:npm',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadTranscript('MainView'),
        children: [
            {
                path: 'detail',
                name: 'Detail Student',
                component: loadTranscript('UserDetail'),
            },
            {
                path: 'krs',
                name: 'Transkrip KRS',
                component: loadTranscript('KRS'),
            },
            {
                path: 'khs',
                name: 'Transkrip KHS',
                component: loadTranscript('KHS'),
            },
            {
                path: 'dhs',
                name: 'Transkrip DHS',
                component: loadTranscript('DHS'),
            },
            {
                path: 'cpl',
                name: 'Transkrip CPL',
                component: loadTranscript('CPL'),
            },
       
        ]
    },
    {
        path: '/my-transcript',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadTranscript('MainView'),
        children: [
            {
                path: 'detail',
                name: 'My Transcript',
                component: loadTranscript('UserDetail'),
            },
            {
                path: 'krs',
                name: 'My Transcript KRS',
                component: loadTranscript('KRS'),
            },
            {
                path: 'khs',
                name: 'My Transcript KHS',
                component: loadTranscript('KHS'),
            },
            {
                path: 'dhs',
                name: 'My Transcript DHS',
                component: loadTranscript('DHS'),
            },
            {
                path: 'cpl',
                name: 'My Transcript CPL',
                component: loadTranscript('CPL'),
            },
       
        ]
    },
]

export default transcriptRoute